import { SeekIndicatorRoot } from "../../../../../ui/seek-indicator/root.js";
import { SeekIndicatorValue } from "../../../../../ui/seek-indicator/value.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/chevron.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/feedback/seek-indicator.tsx
/** @jsxImportSource react */
function SeekIndicator({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(SeekIndicatorRoot, {
		className: (state) => cn("media-seek-indicator", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: "media-seek-indicator-icon" }), /* @__PURE__ */ jsx(SeekIndicatorValue, { className: "media-seek-indicator-value" })]
	});
}
//#endregion
export { SeekIndicator };

//# sourceMappingURL=seek-indicator.js.map